import React, { useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Typography } from "@mui/material";

import CommonTableHead from "../../../../../common/CommonTableHead";
import ContributorInvitesTableRow from "../ContributorInvitesTableRow/ContributorInvitesTableRow";
import {
  ContributorInvitesTableHeadCells,
  getComparator,
  stableSort,
} from "../../../../../constants";

const ContributorInvitesTable = ({
  invitesData,
  onStatusChange,
  onAddClick,
}) => {
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("organizationName");

  const initializeColumnWidths = () => {
    const widths = {};
    ContributorInvitesTableHeadCells.forEach((cell) => {
      widths[cell.id] = cell.width || 150;
    });
    return widths;
  };

  const [columnWidths, setColumnWidths] = useState(initializeColumnWidths);

  const handleColumnResize = (columnId, newWidth) => {
    setColumnWidths((prev) => ({
      ...prev,
      [columnId]: newWidth,
    }));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedRows = stableSort(invitesData, getComparator(order, orderBy));

  return (
    <Box sx={{ width: "100%", mt: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Avenir Book, sans-serif",
            fontWeight: 700,
            fontSize: 16,
            color: "#020303",
          }}
        >
          Contributor
        </Typography>
        {onAddClick && (
          <Button
            variant="contained"
            onClick={onAddClick}
            sx={{
              textTransform: "none",
              fontFamily: "Avenir Book, sans-serif",
              fontSize: 13,
              backgroundColor: "#00A7CD",
              "&:hover": { backgroundColor: "#0090b0" },
              minWidth: 60,
              height: 30,
              padding: "4px 16px",
            }}
          >
            Add
          </Button>
        )}
      </Box>
      <Paper sx={mainContainerStyles}>
        <TableContainer
          style={{
            border: "none",
            boxShadow: "none",
            maxHeight: "400px",
          }}
        >
          <Table stickyHeader aria-labelledby="contributor-invites-table">
            <CommonTableHead
              numSelected={0}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={() => {}}
              onRequestSort={handleRequestSort}
              rowCount={sortedRows.length}
              tableHeadCells={ContributorInvitesTableHeadCells}
              columnWidths={columnWidths}
              onColumnResize={handleColumnResize}
              hideCheckbox={true}
            />
            <TableBody>
              {sortedRows.map((row, index) => {
                const numberType = index % 2 === 0;
                return (
                  <ContributorInvitesTableRow
                    key={row.id}
                    row={row}
                    numberType={numberType}
                    onStatusChange={onStatusChange}
                    columnWidths={columnWidths}
                  />
                );
              })}
              {sortedRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No contributor invites found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default ContributorInvitesTable;

const mainContainerStyles = {
  maxWidth: "100%",
  mb: 1,
  border: "none",
  boxShadow: "none",
};
